import { useEffect, useState } from 'react';
import { collection, query, where, onSnapshot } from 'firebase/firestore';
import { db } from '../firebase/config';

// Org-betalte direktefakturaer for en organisasjon (lesbare for aktive medlemmer).
// Reglene avviser spørringen uten payerType == 'org'. Likhetsfiltre krever ingen sammensatt indeks.
export function useOrgDirectInvoices(orgId) {
  const [invoices, setInvoices] = useState([]);
  const [loading, setLoading]   = useState(!!orgId);

  useEffect(() => {
    if (!orgId) {
      setInvoices([]);
      setLoading(false);
      return undefined;
    }
    setLoading(true);
    const q = query(
      collection(db, 'invoices'),
      where('orgId', '==', orgId),
      where('payerType', '==', 'org')
    );
    return onSnapshot(q, (snap) => {
      setInvoices(snap.docs.map(d => ({ id: d.id, ...d.data() })).filter(i => i.kind));
      setLoading(false);
    }, (err) => {
      console.error('useOrgDirectInvoices:', err);
      setInvoices([]);
      setLoading(false);
    });
  }, [orgId]);

  return { invoices, loading };
}
